
import wx from 'weixin-js-sdk';
import tabsilde from '@/components/tabslideTamplete.vue';
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'

import {fetch,promptMessage } from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import {overscroll} from '../../../static/js/preventWXUp';
import axios from 'axios';
import $ from 'jquery';
export default {
data(){
return{
tabIndex:0,
contentH:0,
tabList: ['选项一435345435345','选项二2','选项三3','选项一4','选项二5','选项三6'],
hispital:'',
inspectionItem:'',
hispitalOption:[],
inspectionItemOption: [],
inlineDescList: [
{key: '1', value: 'Tiger is good', inlineDesc: 'Tiger is the king of mountain'},
{key: '2', value: 'Lion is better', inlineDesc: 'Lion is the king of woods'},
{key: '3', value: 'Camel is best, no inline-desc'},
{key: '4', value: 'Tiger is good', inlineDesc: 'Tiger is the king of mountain'},
{key: '5', value: 'Lion is better', inlineDesc: 'Lion is the king of woods'},
{key: '6', value: 'Camel is best, no inline-desc'},
{key: '7', value: 'Tiger is good', inlineDesc: 'Tiger is the king of mountain'},
{key: '8', value: 'Lion is better', inlineDesc: 'Lion is the king of woods'},
{key: '9', value: 'Camel is best, no inline-desc'},
{key: '10', value: 'Camel is best, no inline-desc'},
{key: '11', value: 'Tiger is good', inlineDesc: 'Tiger is the king of mountain'},
{key: '12', value: 'Lion is better', inlineDesc: 'Lion is the king of woods'},
{key: '13', value: 'Camel is best, no inline-desc'}
],
inlineDescListValue: [],
}
},
components: {
XHeader,'V-tabsilde':tabsilde,Cell,Group, PopupRadio,XButton, Tab, TabItem, Sticky, Swiper, SwiperItem, Checklist
},
methods:{
projectchange(){},
tabClick(index){
this.tabIndex = index
},
windResize(){
this.contentH = window.innerHeight -46-45 - parseInt($('.tab').css('height')) - parseInt($('.chooseProject').css('height')) -10
},
getlocations(hos){
var _this = this;
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)).then(response => {
/* console.log(response)*/
this.weixindata = response.data;
wx.config({
debug: false,
appId: _this.weixindata.appId,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
jsApiList: ['checkJsApi', 'openLocation', 'getLocation']
});
}).catch(function (error) {
promptMessage('获取appid失败: ' +error);

})
var _this = this;
wx.ready(function () {
wx.checkJsApi({
jsApiList: ['getLocation'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
success: function(res) {

}
});
wx.getLocation({
type:'wgs84',
fail:function (erorr) {

},
success:function(res){
var latitude = res.latitude; 
var longitude = res.longitude; 
function toRad(d) {  return d * Math.PI / 180; }
_this.hosArry = [];
for(let i =0;i<hos.length;i++){
hos[i]['location'] = hos[i]['location'].split(',');
hos[i]['distance'] = _this.getDisance(latitude,longitude, hos[i]['location'][0], hos[i]['location'][1]);
_this.hosArry.push(_this.getDisance(latitude,longitude, hos[i]['location'][0], hos[i]['location'][1]));
}
_this.hosArry.sort(function (a, b) {
return a-b;
});
for(let i =0;i<hos.length;i++){
if(_this.hosArry[0] ==hos[i].distance){
_this.hispital = hos[i]['areaId'];
}
}
}
});


});
},
getDisance(lat1, lng1, lat2, lng2) {//lat为纬度, lng为经度, 一定不要弄错
var dis = 0;
var radLat1 = this.toRad(lat1);
var radLat2 = this.toRad(lat2);
var deltaLat = radLat1 - radLat2;
var deltaLng = this.toRad(lng1) - this.toRad(lng2);
var dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
return parseInt(dis * 6378137);
},
toRad(d) {
return d * Math.PI / 180;
},
gethospital(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.getUserId();
this.getinspectionItem();
fetch('post',urlConfig.getHospitalMsg).then(response => {
console.log(response,4)
this.getlocations(response);
for(let i=0;i<response.length;i++){
this.hispitalOption.push({key:response[i].areaId,value:response[i].areaName});
}
}).catch(error => {

});
},
getinspectionItem(){
fetch('get',urlConfig.getMachineinspectionUrl).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
for(let i=0;i<response.length;i++){
this.inspectionItemOption.push({key:response[i].id,value:response[i].itemName});
}
}).catch(error => {

})
}, //获取检查项目
getUserId(){
fetch('get',urlConfig.GetSfzh + '?openid='+this.$route.query.openid).then(response => {
this.getPersonInfoId(response.sfzh);

}).catch(error => {

})
},
getPersonInfoId(sfzh){
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.personId = response.personInfoId;

}).catch(error => {

})

},
submilt(){
if(this.hispital!='' && this.inlineDescListValue.length !=0){
fetch('post',urlConfig.SaveSelfFillingMachineUrl,[{personId:this.personId,areaId:this.hispital,ssdId:this.inspectionItem}]).then(response => {
promptMessage('提示','开单成功，请缴费');
window.location.href="http://app.cdxt.com.cn/scvif/pages/payMain.html?t=" + new Date().getTime();
}).catch(error => {

})
}else{
if(this.hispital ==''){
promptMessage('提示','未选择院区！');
}else{
promptMessage('提示','未选择开单项目！');
}
}

}//提交

},
mounted(){
getken(this.gethospital);
this.windResize();
overscroll(document.querySelector('.scroll'));
}
}



// WEBPACK FOOTER //
// ./src/project/selfHelpFilingProject/selfFillingMachine.vue